import CREATE_CUSTOMIZED_PLAN from './CreateCustomizedPlan.graphql'
import UPDATE_CUSTOMIZED_PLAN from './UpdateCustomizedPlan.graphql'
import UPDATE_TRIP_DETAILS from './UpdateTripDetails.graphql'
import CREATE_TRIP_DETAILS from './CreateTripDetails.graphql'
import CONNECT_TRIP_DETAILS from './ConnectTripDetails.graphql'
import CONNECT_INVITED_USER from './ConnectInvitedUser.graphql'
import GET_GURU_NEW_ORDERS from './GetGuruNewOrders.graphql'

export default {
  CREATE_CUSTOMIZED_PLAN,
  UPDATE_CUSTOMIZED_PLAN,
  CREATE_TRIP_DETAILS,
  UPDATE_TRIP_DETAILS,
  CONNECT_TRIP_DETAILS,
  CONNECT_INVITED_USER,
  GET_GURU_NEW_ORDERS
}



// WEBPACK FOOTER //
// src/graphql/TripForm/index.js